const translations = {
  "en": {
    "Any": "Any"
  },
  "ko": {
    "Any": "어떤"
  },
  "zh": {
    "Any": "任何"
  },
  "zh-tw": {
    "Any": "任何"
  },
  "vi": {
    "Any": "Bất kỳ"
  },
  "es": {
    "Any": "Cualquier"
  },
  "tr": {
    "Any": "Herhangi bir"
  },
  "fr": {
    "Any": "N'importe quel"
  },
  "ja": {
    "Any": "任意の"
  }
};

export default translations;
